export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_09.85dc0c88.jpg";